import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, palette }: Theme) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 32,
    padding: '0 24px',

    '& h1, & $subtitle': {
      fontSize: 40,
      fontFamily: 'Merriweather',
      fontWeight: 'bold',
      color: palette.text.primary,
      lineHeight: '46px',
      textAlign: 'center',
      [breakpoints.down('xs')]: {
        fontSize: 32,
        lineHeight: '42px',
      },
    },
    '& h1': {
      margin: '20px 0 0',
    },
    '& $subtitle': {
      display: 'block',
      margin: '0 0 20px',
    },
  },
  subtitle: {},
  logoContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
    width: '100%',
  },
  loginButton: {
    marginLeft: 20,
  },
  loginButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    justifySelf: 'end',
  },
  hamburgerMenu: {
    marginLeft: 20,
    display: 'none',
  },
  [breakpoints.down(769)]: {
    loginButton: {
      display: 'none',
    },
    hamburgerMenu: {
      display: 'block',
      marginLeft: 10,
      marginRight: 0,
    },
  },
}));
